module.exports = "https://img.xiyuyouxi.com/saas/img/menu6.5f3c166b.png";